import React from 'react';
import { Image } from 'react-bootstrap';

const SuccessMsg = ({
    match: { params: { email = null } = {} } = {},
    className = '',
    icon = '/images/icons/success_icon.png'
}) => {
    return (
        <div className="success-msg-modal">
            <div className="content-wrap">
                <Image src={icon} />
                <h4 className="success-msg-header">Thank you</h4>
                <p className="success-msg-description">{`We'll get back to you at ${email}`}</p>
            </div>
        </div>
    );
}

export default SuccessMsg;